import React from "react";
import { ArrowRight, Phone, Sparkles } from "lucide-react";
import { nzTaxLink, bookCallLink } from "@/lib/conversion";

/**
 * Compact "Hire NZ Taxation Ltd" CTA card — used at the bottom of every
 * calculator. Two variants: "compact" and "full".
 */
export default function HireUsCTA({
  campaign = "calculator-cta",
  compact = false,
  headline,
  subline,
}) {
  const heading =
    headline ||
    (compact
      ? "Want this done properly?"
      : "Done with the maths? Let us do it for you.");
  const sub =
    subline ||
    (compact
      ? "We're NZ Taxation Ltd — IRD-registered tax agents in Auckland."
      : "Free calculators are great for a sense check. For monthly tax estimates from your real numbers, registered tax agents handling IRD, and proper bookkeeping — that's our day job.");

  return (
    <div
      className="mt-10 border border-[var(--primary)]/40 bg-gradient-to-br from-[var(--primary)]/[0.06] to-transparent"
      data-testid={`hire-us-cta-${campaign}`}
    >
      <div className="p-6 md:p-8 grid md:grid-cols-3 gap-6 items-center">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <Sparkles size={14} className="text-[var(--primary)]" />
            <div className="label-mono">By NZ Taxation Ltd</div>
          </div>
          <h3 className="font-display text-2xl md:text-3xl mt-2 leading-tight">
            {heading}
          </h3>
          <p className="text-zinc-300 mt-3 text-sm leading-relaxed max-w-xl">{sub}</p>
        </div>
        <div className="flex flex-col gap-3 md:items-end">
          <a
            href={nzTaxLink("/#pricing", campaign)}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary justify-center w-full md:w-auto"
            data-testid={`hire-us-pricing-${campaign}`}
          >
            See plans <ArrowRight size={14} />
          </a>
          <a
            href={bookCallLink(campaign)}
            className="btn-ghost justify-center w-full md:w-auto"
            data-testid={`hire-us-book-${campaign}`}
          >
            <Phone size={14} /> Book free call
          </a>
        </div>
      </div>
    </div>
  );
}
